const CONFIGURED_HOST = (process.env.NEXT_PUBLIC_HOST || "").replace(
  /^https?:\/\//,
  "",
);
const PRODUCTION_SERVICE_HOST = "www.chesshotel.com";
const RUSSIA_SERVICE_HOST = "direct.chesshotel.com";
const RUSSIA_FRONTEND_HOSTS = new Set([
  "ru.chesshotel.com",
  "direct.chesshotel.com",
]);

const isLocalHost = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?$/.test(
  CONFIGURED_HOST,
);

export const USE_PROD = !isLocalHost;

export function getConfiguredHost() {
  return CONFIGURED_HOST;
}

function getRuntimeHost() {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.hostname.toLowerCase();
}

export function getServiceHost() {
  if (!USE_PROD || process.env.NEXT_PUBLIC_TEST === "true") {
    return CONFIGURED_HOST;
  }

  const runtimeHost = getRuntimeHost();
  if (
    RUSSIA_FRONTEND_HOSTS.has(runtimeHost) ||
    RUSSIA_FRONTEND_HOSTS.has(CONFIGURED_HOST.toLowerCase())
  ) {
    return RUSSIA_SERVICE_HOST;
  }

  return PRODUCTION_SERVICE_HOST;
}
